import {lazyGet} from "@dp-instant/core";
import {Localize} from "@dp-instant/i18n";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import "./LevelTitle.less";

export const LevelTitle = () => {
    const model: GameModel | undefined = lazyGet<GameModel>(TypesGame.model);
    return (
        <div className="level-number">
            {Localize.get("ui-menu-level_num", "LEVEL")} {model?.absoluteLevelNum || "-"}
        </div>
    );
};
